import React from 'react';
import { UAParser } from 'ua-parser-js';
import Link from 'next/link';

const parser = new UAParser();

const deviceSpecificLocationInstructions = {
    'Mac OS': {
        Chrome: 'https://support.google.com/chrome/answer/142065?co=GENIE.Platform%3DDesktop&hl=sl',
        Safari: 'https://support.apple.com/guide/mac-help/allow-apps-to-detect-the-location-of-your-mac-mh35873/mac#:~:text=Specify%20which%20apps%20and%20system%20services%20can%20use%20Location%20Services',
        Firefox:
            'https://support.mozilla.org/en-US/kb/does-firefox-share-my-location-websites#w_how-do-i-undo-a-permission-granted-to-a-site',
        Brave: 'https://support.brave.com/hc/en-us/articles/360018205431-How-do-I-change-site-permissions-',
        Opera: 'https://help.opera.com/en/latest/web-preferences/#location'
    },
    Windows: {
        Chrome: 'https://support.google.com/chrome/answer/142065?co=GENIE.Platform%3DDesktop&hl=sl',
        Safari: 'https://support.apple.com/guide/mac-help/allow-apps-to-detect-the-location-of-your-mac-mh35873/mac#:~:text=Specify%20which%20apps%20and%20system%20services%20can%20use%20Location%20Services',
        Firefox:
            'https://support.mozilla.org/en-US/kb/does-firefox-share-my-location-websites#w_how-do-i-undo-a-permission-granted-to-a-site',
        Brave: 'https://support.brave.com/hc/en-us/articles/360018205431-How-do-I-change-site-permissions-',
        Opera: 'https://help.opera.com/en/latest/web-preferences/#location'
    },
    iOS: 'https://support.apple.com/en-us/HT207092',
    Android: 'https://support.google.com/chrome/answer/142065?co=GENIE.Platform%3DAndroid&hl=en'
};

const getLocationInstructionsLink = () => {
    const { browser, os } = parser.getResult();
    if (deviceSpecificLocationInstructions?.[os.name]) {
        if (typeof deviceSpecificLocationInstructions[os.name] === 'string') {
            return deviceSpecificLocationInstructions[os.name];
        }
        return deviceSpecificLocationInstructions[os.name][browser.name];
    }
    return null;
};

const LocationNoPermission = () => {
    const instructionsLink = getLocationInstructionsLink();

    return (
        <>
            <h2 className="text-brand">Nimamo dovoljenja za dostop do tvoje lokacije</h2>
            <p className="mt-6 mb-2 max-w-2xl mx-auto">
                Izletnih idej v tvoji bližini ni mogoče prikazati, saj nimamo dovoljenja za dostop do tvoje lokacije.
                {!instructionsLink && 'Dovoljenje lahko spremeniš v nastavitvah svojega brskalnika.'}
                {instructionsLink && (
                    <>
                        {' '}
                        Navodila za vklop lokacije na svoji napravi lahko prebereš{' '}
                        <Link className="text-brand underline font-bold" target="_blank" href={instructionsLink}>
                            tukaj
                        </Link>
                        .
                    </>
                )}
            </p>
            <p className="mt-8">
                Če potrebuješ pomoč nam piši na{' '}
                <a className="underline" href="mailto:info@kamzavikend.si">
                    info@kamzavikend.si
                </a>
                .
            </p>
        </>
    );
};

export default LocationNoPermission;
